export default {
  baseUrl: "https://dev.heldenplaner.de/api/v2",
  headers: [
    {
      key: "Accept",
      value: "application/json"
    },
    {
      key: "x-pkss-domain",
      value: "pkssdev.heldenplaner.de"
    },
    {
      key: "Accept-Language",
      value: navigator.language.split('-')[0]
    }
  ],
  auth: {
    verifyOtp: "verify-otp",
    verifyLastname: "name-check",
    verifyCell: "number-check",
    logout: "logout",
    acceptContract: "accept-contract",
    profile: "me",
    resendOtp: "resend-otp",
    deleteReference: "deleteReference"

  },
  invitation: {
    verify: "verify-invitation/{uid}"
  },
  offer: {
    list: "offers",
    anonymousList: "offers/anonymous",
    details: "offers/{id}",
    favorite: {
      list: "offers/favorites",
      toggle: "offers/favorites/toggle"
    },
    toggleCustomer: "offers/customer/toggle"
  },
  furtherOffers: {
    list: "furtherOffers",
    anonymousList: "furtherOffers/anonymous",
    details: "offers/{id}",
    favorite: {
      list: "furtherOffers/favorites",
      toggle: "furtherOffers/favorites/toggle"
    },
    toggleCustomer: "furtherOffers/customer/toggle"
  },
  info: {
    faq: "info/faq",
    meta: "info/meta",
    request: "info/request"
  },
  filters: {
    list: "filters",
    update: "filters",
    resetFilters: "resetFilter"
  },
  applications: {
    list: "applications",
    apply: "applications",
    delete: "applications",
    revoke: "application/revoke/{id}",
    showFamily: "showFamily/{pkKundeExcId}",

  },
  countryCode: ""
};
